import React from 'react';
import { BrowserRouter as Router, Switch, Route } from "react-router-dom";
import './stylesheet.css';
import './App.css';
import WelcomePage from './components/WelcomePage';
import AboutPage from './components/AboutPage';
import TermsPage from './components/TermsPage';

function App() {
  return (
    <Router>
        <Switch>
            <Route path="/" exact component={WelcomePage} />
            <Route path="/about" exact component={AboutPage} />
            <Route path="/terms" exact component={TermsPage} />
        </Switch>
    </Router>
  );
}

export default App;
